import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/1-Inkasso.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/2-Inkasso.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/3-Inkasso.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/articleCardSmilingGirl.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/ArticleGardening.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/articleSimilingGirl.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleBottomLeftVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleBottomRightVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleCardBackgroundMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleFirstMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleSecondMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleSmilingGrilMobileImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleThirdMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleTopLeftVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/articleTopRightVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogCardMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSecFirstCard.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSecSecondCard.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/secondAriticleCardLeftVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/secondAriticleCardMobileTopVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/secondAriticleCardRightVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Food.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Icons/pilResurs13303.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Icons/PurpleNextArrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/blogPageSmilingGirlMobileImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/blueFinfabIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/smilingManWithPhone.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/manInCoat.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/client/RedirectButton.client.jsx");
